import commeDesGarconsHommePlus2022ssFlowerExistence from "./comme-des-garcons-homme-plus-2022ss-flower-existence";
import commeDesGarconsHommePlus2020ssOrlando from "./comme-des-garcons-homme-plus-2020ss-orlando";
import commeDesGarconsLineGuide from "./comme-des-garcons-line-guide";
import maisonMargielaNumberTagGuide from "./maison-margiela-number-tag-guide";
import diorHommeHediSlimaneArchiveGuide from "./dior-homme-hedi-slimane-archive-guide";

export const COLLECTIONS = {
  flower: commeDesGarconsHommePlus2022ssFlowerExistence,
  orlando: commeDesGarconsHommePlus2020ssOrlando,
  cdgLineGuide: commeDesGarconsLineGuide,
  maisonMargielaNumberTagGuide: maisonMargielaNumberTagGuide,
  diorHommeHediSlimaneGuide: diorHommeHediSlimaneArchiveGuide,
};
